import type { RouteRecordRaw } from 'vue-router';
import { FeatureFlags } from '@/types/featureFlags';

const routes: RouteRecordRaw[] = [
  {
    path: '/agents',
    name: 'Agents',
    component: () => import('@/views/AgentsView.vue'),
    meta: {
      layout: 'LayoutAuthenticated',
      requiresAuth: true,
      requiredLDFlags: [FeatureFlags.AGENTS_ENABLED],
    },
  },
];

export default routes;
